import { Link } from "react-router-dom";
import { useMerchant } from "@/lib/useMerchant";
import DashboardHeader from "@/components/DashboardHeader";
import DashboardFooter from "@/components/DashboardFooter";
import BackToDashboard from "@/components/BackToDashboard";
import AnalyticsPanel from "@/components/AnalyticsPanel";

export default function Analytics() {
  const { me } = useMerchant();

  return (
    <div className="min-h-screen bg-cream">
      <DashboardHeader me={me} />
      <main className="mx-auto max-w-7xl px-6 pt-10 md:px-10">
        <BackToDashboard />

        <p className="text-xs font-bold uppercase tracking-[0.2em] text-hotpink">Analytics</p>
        <h1 className="mt-2 font-display text-4xl font-black leading-tight tracking-tighter md:text-5xl">
          What your DMs are really doing.
        </h1>
        <p className="mt-3 max-w-xl text-ink/60">
          Revenue, chats and conversion at a glance — Pro adds the DM → Paid funnel, order status
          breakdown and return reasons.{" "}
          <Link to="/analytics-guide" className="font-semibold text-hotpink hover:underline">
            What do these numbers mean? →
          </Link>
        </p>

        <div className="mt-8">
          <AnalyticsPanel merchant={me} />
        </div>
      </main>
      <DashboardFooter />
    </div>
  );
}
